/* eslint-disable no-restricted-globals */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button as MuiButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import moment from "moment/moment";
import { Helmet } from "react-helmet";
import EmptyFileIcon from "../../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../../components/common/Loader/Loader";
import Modal from "../../../../components/common/Modal/Modal";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../../contants";
import useParamsQuery from "../../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../../redux/selectors/user";
import Reports from "../../../../services/api/reports";
import { formDataToObject, isEmptyObj } from "../../../../utils/helper";
import styles from "../FriendSearch.styles";
import ReportTable from "../FriendsReportsTable/FriendTrendsTable";
import OrganizationSearch from "../../SubscriptionReports/OrganizationSearchReports";
import AdvanceSearch from "../../SubscriptionReports/Components/AdvanceSearchSubscriptionTrends";
import {
  getFilters,
  getFormattedQuery,
  getRoutePathforNewFriendTrends,
  handleDependencyFilter,
} from "../FriendToMemberTrend/utils";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { SET_PERIOD_DATE } from "../../../../redux/actionTypes/meta";
import ExportButton from "../FriendToMemberTrend/Components/ExportButton";
import Toast from "../../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

const initialFormValue = {
  dateFrom: "",
  dateTo: "",
};

function NewFriendTrends() {
  const TITLE = "New Friend Trends Report - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);

  const [dateFrom, setDateFrom] = useState(initialFormValue.dateFrom);
  const [dateTo, setDateTo] = useState(initialFormValue.dateTo);
  const [dateValueFrom, setDateValueFrom] = useState(null);
  const [dateValueTo, setDateValueTo] = useState(null);

  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
    // Reset date states
    setDateFrom("");
    setDateTo("");
    setDateValueFrom(null);
    setDateValueTo(null);
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePathforNewFriendTrends()}?${query}`);
    } else {
      navigate(`${getRoutePathforNewFriendTrends()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const handleDateChangeFrom = (newValue) => {
    if (newValue !== null) {
      const newDateValue = new Date(newValue);
      const selectedDate = moment(newDateValue);
      const firstDayOfMonth = selectedDate.clone().startOf("month");
      const localFirstDayOfMonth = moment(firstDayOfMonth).format("YYYY-MM-DD");
      setDateFrom(localFirstDayOfMonth);
    } else {
      setDateFrom("");
    }
    setDateValueFrom(newValue);
  };

  const handleDateChangeTo = (newValue) => {
    if (newValue !== null) {
      const newDateValue = new Date(newValue);
      const selectedDate = moment(newDateValue);
      const lastDayOfMonth = selectedDate.clone().endOf("month");
      const localLastDayOfMonth = moment(lastDayOfMonth).format("YYYY-MM-DD");
      setDateTo(localLastDayOfMonth);
    } else {
      setDateTo("");
    }
    setDateValueTo(newValue);
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const validateAndFetchData = (formattedQuery, toastCtx, setLoading) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      toastCtx.show("Please enter Area", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    if (
      !formattedQuery.hasOwnProperty("dateFrom") ||
      formattedQuery.dateFrom === "" ||
      !formattedQuery.hasOwnProperty("dateTo") ||
      formattedQuery.dateTo === ""
    ) {
      toastCtx.show("Please enter date", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    const dFrom = new Date(formattedQuery.dateFrom);
    const dTo = new Date(formattedQuery.dateTo);

    if (isNaN(dFrom) || isNaN(dTo)) {
      toastCtx.show("Invalid date format", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    if (dFrom > dTo) {
      toastCtx.show(
        "Start date cannot be after the end date",
        AlertStatus.ERROR
      );
      setLoading(false);
      return false;
    }

    return true;
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (queryParams) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
      });

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const response = await Reports.NewFriendTrendsReport(formattedQuery);
        if (response.code === 200 && response.message === "") {
          setIsLoading(false);
        }

        const { data } = response;

        setSearchData(data);
        setPageSize(pageSize);

        setTimeout(() => {
          setIsLoading(false);

          if (data?.length > 0) {
            if (allowModalRef.current) {
              setOpenResultModal(true);
              setShowSearchResult(true);
              allowModalRef.current = false;
            }
          } else {
            setShowToast({
              severity: "error",
              message: "No data found",
            });
            setOpenResultModal(false);
            setShowSearchResult(false);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    if (dateFrom !== "") {
      formData.dateFrom = dateFrom;
    }
    if (dateTo !== "") {
      formData.dateTo = dateTo;
    }

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    if (formData.dateTo) {
      setMetaDataInRedux(
        SET_PERIOD_DATE,
        moment(formData.dateTo).format("MMMM, YYYY")
      );
    }

    const query = queryString.stringify(formData);
    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);
    fetchSearchData(formData);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      if (
        queryObject.pageNumber !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* Organization Structure */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* Advanced Search - Responsive width */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Advanced Search
              </div>
              <div style={{ width: isMobile ? "95%" : "85%" }}>
                <AdvanceSearch
                  formRef={formRef}
                  disabledOSKeys={disabledOSKeys}
                  handleDateChangeFrom={handleDateChangeFrom}
                  handleDateChangeTo={handleDateChangeTo}
                  dateValueFrom={dateValueFrom}
                  dateValueTo={dateValueTo}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}
        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Export + Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <ExportButton
                    data={searchData}
                    exportFunction={Reports.downloadNewFriendTrendReport}
                  />
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <ReportTable searchData={searchData} />
              </div>
            </>
          ) : showSearchResult ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "30px 0",
                color: "#777",
              }}
            >
              <EmptyFileIcon width={100} />
              <span>No data found with current Filters</span>
            </div>
          )}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default NewFriendTrends;
